var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<button class="fa fa-arrow-up btn btn-default"data-bind="\n		click: scrollToTop\n	"></button>';
}
return __p;
};
